import { Injectable } from '@angular/core';
import { LazyLoadEvent } from 'primeng/api';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { FleetRequestModel } from '../models/fleet-request.model';
import { FleetVehicleModel } from '../models/fleet-vehicle.model';
import { FleetModel } from '../models/fleet.model';
import { FleetRenewalInviteRequestModel } from '../models/fleet-renewal-invite-request.model';
import { Observable } from 'rxjs';

@Injectable()
export class FleetService extends BaseApiService {
    saveFleet(fleet: FleetModel) {
        return this.post('TitleRegistration/Fleet/Save', fleet);
    }

    saveFleetVehicles(fleetId: number, fleetVehicles: FleetVehicleModel[]) {
        return this.post('TitleRegistration/Fleet/' + fleetId + '/FleetVehicles', fleetVehicles);
    }

    removeFleetVehicles(fleetId: number, fleetVehicles: FleetVehicleModel[]) {
        return this.post('TitleRegistration/Fleet/' + fleetId + '/FleetVehiclesToRemove', fleetVehicles);
    }

    getFleet(fleetId: number) {
        return this.get('TitleRegistration/Fleet/' + fleetId);
    }

    getFleetsByCustomerNumbers(customerNumbers: number[]) {
        return this.post('TitleRegistration/Fleet/Customers', customerNumbers);
    }

    getFleetVehicles(fleetId: number) {
        return this.get('TitleRegistration/Fleet/' + fleetId + '/Vehicles');
    }

    getFleetVehiclesLazyLoad(fleetId: number, lazyLoadEvent: LazyLoadEvent) {
        return this.post('TitleRegistration/Fleet/' + fleetId + '/Vehicles', lazyLoadEvent);
    }

    saveFleetRequest(fleetRequest: FleetRequestModel): Observable<FleetRequestModel> {
        return this.post('TitleRegistration/Fleet/Request/Save', fleetRequest);
    }

    getFleetRequest(fleetRequestId: number): Observable<FleetRequestModel> {
        return this.get(`TitleRegistration/Fleet/Request/${fleetRequestId}`);
    }

    saveFleetRenewalInviteRequest(fleetRenewalInviteRequest: FleetRenewalInviteRequestModel) {
        return this.post('TitleRegistration/Fleet/RenewalInviteRequest/Save', fleetRenewalInviteRequest);
    }

    getFleetByVehicleId = (vehicleId: number) => this.get('TitleRegistration/Fleet/Vehicle/' + vehicleId);

    getFleetVehicleByVehicleId = (vehicleId: number) => this.get('TitleRegistration/Fleet/FleetVehicle/' + vehicleId);

    verifyOpenCashDrawer = () => this.get('TitleRegistration/Fleet/CashDrawer/Verify');

    updateFleetExpirationDate(fleetId: number) {
        return this.post('TitleRegistration/Fleet/ExpirationDate/Update', fleetId);
    }

    getFleetVehicleCountByFleetId(fleetId: number) {
        return this.get('TitleRegistration/Fleet/' + fleetId + '/Count');
    }

    /**
     * Gets the current user's profile
     * @returns A user profile model of type any
     */
    public getUserProfile() {
        return this.get('Foundation/User/Profile');
    }
}
